import { z } from "zod";
import { cepSchema } from "../common/cep";
import { brazilianStateSchema } from "../user/cro";

export const addressSchema = z.object({
  zipCode: cepSchema,
  address: z.string().trim().min(2, "Logradouro obrigatório").max(200),
  addressNumber: z.string().trim().max(10).optional(),
  addressComplement: z.string().trim().max(100).optional(),
  neighborhood: z.string().trim().min(2, "Bairro obrigatório").max(100),
  city: z.string().trim().min(2, "Cidade obrigatória").max(100),
  state: brazilianStateSchema,
});

export type AddressInput = z.infer<typeof addressSchema>;

/** Endereço exigido ao criar organização: tudo obrigatório, menos o complemento. */
export const requiredAddressSchema = addressSchema.extend({
  addressNumber: z.string().trim().min(1, "Número obrigatório").max(10),
});

/** Todos os campos opcionais (uso em onboarding quando endereco nao e obrigatorio). */
export const optionalAddressSchema = addressSchema.partial();
export type OptionalAddressInput = z.infer<typeof optionalAddressSchema>;
